export default function CalculoCantidadDias(fecha, estado) {
  let x = new Date(fecha);
  let y = new Date();
  const diffInDays = (x - y) / (1000 * 60 * 60 * 24);
  const diferenciaDias = Math.round(diffInDays);
  let alarmaDias = false;
  if (diferenciaDias >= 5 && estado !== "Firmado") {
    alarmaDias = true;
  }
  return alarmaDias;
}
